module.exports = new __parcel__URL__("c1s6.8653cb79.png").toString();